import { Button } from "@/components/ui/button/button";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { EC_RECEIPT_SEARCH_TYPE_OPTIONS } from "./constants";
import { useHandleSearchActions } from "./hooks";

import type { SearchTypeForECReceiptList } from "../../../../model/constants";
import type { OnSearchSalesMastListProps } from "../../../../model/use-case/use-search-reservation-list";

type Props = {
	// 収支の検索
	onSearchSalesMastList: (props: OnSearchSalesMastListProps) => void;

	searchType: SearchTypeForECReceiptList;
	onSetSearchType: (type: SearchTypeForECReceiptList) => void;
};

export const BasicSearchSection = ({ searchType: _searchType, onSetSearchType, onSearchSalesMastList }: Props) => {
	const {
		searchState,
		//
		searchType,
		disabled,
		//
		// 予約タイプの変更
		handleChangeSearchType,
		// 日付の変更
		handleChangeFromAndTo,
		// レシートIDの変更
		handleChangeReceiptID,
		// 修正の検索
		handleClickSearchSalesMastList,
	} = useHandleSearchActions({
		onSearchSalesMastList,
		searchType: _searchType, //
		onSetSearchType,
	});

	return (
		<div className="grid grid-cols-1 items-center gap-4 gap-x-2 tablet:flex">
			{/* 検索タイプ */}
			<SelectField
				value={searchType}
				options={EC_RECEIPT_SEARCH_TYPE_OPTIONS}
				handleValueChange={handleChangeSearchType}
			/>

			{searchType === "startDtAndEndDt" && (
				<>
					{/* 日付での絞り込み */}
					<DatePickerRange
						selected={{
							from: searchState.from,
							to: searchState.to,
						}}
						showPresetOptions="exclude-future-options"
						onSelect={handleChangeFromAndTo}
						canSelectPastDate
						className="w-full tablet:w-80"
					/>
				</>
			)}

			{searchType === "receiptID" && (
				<>
					{/* 日付での絞り込み */}
					<InputTextField value={searchState.receiptID} handleChange={handleChangeReceiptID} />
				</>
			)}

			<Button type="button" disabled={disabled} onClick={handleClickSearchSalesMastList}>
				検索
			</Button>
		</div>
	);
};

BasicSearchSection.displayName = "BasicSearchSection";
